// react components
import React from 'react'
import {
    DialogActions,
} from '@mui/material'
import {
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
    reduxFormHelpersStateSite,
} from 'data'

// pages
import {
    Button825,
} from 'pages'

type actionObjectType = {
    active?: boolean
    has_active_permission?: boolean
    has_delete_permission?: boolean
    has_edit_permission?: boolean
    has_website?: boolean
    name?: string
    original_image?: string
    staff_permission?: boolean
}

// props
type FormModalAction825Props = {
    actionObjectState?: actionObjectType
    buttonSize?: any
    defaultFields: any
    formActive: boolean
    handleRequired: (stay: boolean, publish?: boolean, another?: boolean) => void
    helpers: reduxFormHelpersStateSite
    object: any
    onCloseModal: (value?: any, forceClose?: boolean) => void
    reverseButtons?: boolean
    setIsDeleteAlertOpen: React.Dispatch<React.SetStateAction<boolean>>
}

// main
export const FormModalAction825: React.FC<FormModalAction825Props> = React.memo(({
    actionObjectState,
    buttonSize,
    defaultFields,
    formActive,
    handleRequired,
    helpers,
    object,
    onCloseModal,
    reverseButtons,
    setIsDeleteAlertOpen,
}) => {

    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    return (
        <DialogActions className={`mo-dialog-footer${reverseButtons ? ' reverse' : ''}`}>
            {actionObjectState?.has_delete_permission && (
                <>
                    {/* Start delete button */}
                    <Button825
                        disabled={!object?.id}
                        color='danger'
                        edit={false}
                        expand='full'
                        onClick={() => setIsDeleteAlertOpen(true)}
                        size={buttonSize}
                        text={reduxText[10201]}
                    />
                    {/* End delete button */}
                </>
            )}
            {/* Start cancel/close button */}
            <Button825
                edit={false}
                expand='full'
                onClick={() => onCloseModal(undefined, true)}
                size={buttonSize}
                text={helpers.buttonDisabled ? reduxText[8353] : reduxText[10207]}
            />
            {/* End cancel/close button */}
            {formActive === undefined
                ? (
                    <>
                        {/* Start save and add another button */}
                        {defaultFields && (
                            <Button825
                                disabled={helpers.buttonDisabled}
                                edit={false}
                                expand='full'
                                onClick={() => handleRequired(false, !formActive, true)}
                                size={buttonSize}
                                text={reduxText[10227]}
                            />
                        )}
                        {/* End save and add another button */}
                        {/* Start save and add another button */}
                        <Button825
                            disabled={helpers.buttonDisabled}
                            edit={false}
                            expand='full'
                            onClick={() => handleRequired(false, !formActive)}
                            size={buttonSize}
                            text={reduxText[10228]}
                        />
                        {/* End save and add another button */}
                    </>
                ) : (
                    <>
                        {/* Start Save as draft button */}
                        {((typeof actionObjectState?.has_active_permission === 'undefined') || actionObjectState?.has_active_permission) && !formActive && (
                            <Button825
                                disabled={helpers.buttonDisabled}
                                edit={false}
                                expand='full'
                                onClick={() => handleRequired(false)}
                                size={buttonSize}
                                text={reduxText[10229]}
                            />
                        )}
                        {/* End Save as draft button */}
                        {/* Start save and add another button */}
                        {defaultFields && (
                            <Button825
                                disabled={helpers.buttonDisabled}
                                edit={false}
                                expand='full'
                                onClick={() => handleRequired(false, !formActive, true)}
                                size={buttonSize}
                                text={reduxText[10227]}
                            />
                        )}
                        {/* End save and add another button */}
                        {(((typeof actionObjectState?.has_active_permission === 'undefined') || actionObjectState?.has_active_permission)) ? (
                            <>
                                {/* Start save and publish button */}
                                <Button825
                                    disabled={helpers.buttonDisabled}
                                    edit={false}
                                    expand='full'
                                    onClick={() => handleRequired(false, !formActive)}
                                    size={buttonSize}
                                    text={formActive ? reduxText[10228] : reduxText[10230]}
                                />
                                {/* End save and publish button */}
                            </>
                        ) : (
                            <>
                                {/* Start save / save and publish button */}
                                <Button825
                                    disabled={helpers.buttonDisabled}
                                    edit={false}
                                    expand='full'
                                    onClick={() => handleRequired(false)}
                                    size={buttonSize}
                                    text={reduxText[10228]}
                                />
                                {/* End save / save and publish button */}
                            </>
                        )}
                    </>
                )}
        </DialogActions>
    )

})
